module.exports = __webpack_public_path__ + "img/station.afad7867.png";